import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Counter from "@/components/Counter";
import { IMAGES, STATS } from "@/lib/content";

export default function About() {
  return (
    <>
      <Seo title="About — DC's Premier Hookah Lounge" description="ChiCha Lounge is Washington DC's premier hookah lounge on historic U Street — premium hookah, craft cocktails and luxury nightlife." path="/about" image={IMAGES.lounge} />
      <PageHero overline="Our Story" title="Luxury Meets Nightlife" subtitle="Born on historic U Street, ChiCha reimagines the DC lounge experience with Miami energy and Dubai polish." image={IMAGES.lounge} />

      <section className="py-20 bg-transparent">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <img src={IMAGES.marbleBar} alt="Inside ChiCha Lounge DC" loading="lazy" className="rounded-2xl w-full h-[500px] object-cover" />
          </Reveal>
          <div>
            <h2 className="font-serif text-4xl md:text-5xl text-neutral-900 leading-tight">A Lounge Built for <span className="text-accent">Unforgettable Nights</span></h2>
            <div className="space-y-5 text-neutral-500 text-lg mt-6 leading-relaxed">
              <p>ChiCha Lounge sits in the heart of Washington DC's most storied nightlife corridor — U Street. We blend matte-black luxury, warm amber lighting and plush velvet seating to create an atmosphere that feels worlds away from the ordinary.</p>
              <p>With 20+ premium hookah flavors, a craft cocktail program inspired by the District, and the city's best DJs, every night at ChiCha is designed to be an experience. Whether you're celebrating, networking or simply unwinding, our team treats every guest like a VIP.</p>
            </div>
            <div className="flex items-center gap-2 mt-8 text-neutral-900"><MapPin size={18} /> 1214 U St NW, Washington, DC</div>
            <div className="flex flex-wrap gap-4 mt-8">
              <Link to="/reservations" className="btn-gold">Reserve a Table</Link>
              <Link to="/gallery" className="btn-ghost">View Gallery</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white border-y border-black/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className="text-center">
              <div className="font-serif text-5xl md:text-6xl text-accent"><Counter value={s.value} suffix={s.suffix} /></div>
              <div className="text-neutral-400 text-xs uppercase tracking-[0.2em] mt-2">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
